import { DocumentPackageType } from '@consigli/types';

import { SecondaryPackageUpload } from './secondary-package-upload';

interface NewPackageProps {
  compareServiceId: DocumentPackageType;
}

export const NewPackage = ({ compareServiceId }: NewPackageProps) => {
  return <SecondaryPackageUpload type={compareServiceId}></SecondaryPackageUpload>;
};
